import { render } from "./bank-account.html?vue&type=template&id=59897070&scoped=true&ts=true&external"
import script from "./bank-account.ts?vue&type=script&lang=ts&external"
export * from "./bank-account.ts?vue&type=script&lang=ts&external"

import "./bank-account.scss?vue&type=style&index=0&id=59897070&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59897070"]])

export default __exports__